export const firebaseConfig = {
    apiKey: "",
    authDomain: "aura-doc.firebaseapp.com",
    projectId: "aura-doc",
    storageBucket: "aura-doc.firebasestorage.app",
    messagingSenderId: "243264351356",
    appId: "1:243264351356:web:ad5ce66917927e80f8adf9",
    measurementId: "G-QYRCK15C2R"
};

export const WORKER_URL = 'https://auradoc-api-proxy.eric-moon.workers.dev';

export async function resolveFirebaseConfig() {
    if (firebaseConfig.apiKey) return firebaseConfig;

    try {
        const response = await fetch('/api/firebase-config', {
            headers: { Accept: 'application/json' },
            cache: 'no-store'
        });
        const data = await response.json();

        if (!response.ok || data.error || !data.config?.apiKey) {
            throw new Error(data.error || 'FIREBASE_API_KEY is not configured.');
        }

        Object.assign(firebaseConfig, data.config);
        return firebaseConfig;
    } catch (error) {
        console.warn('[FirebaseConfig] Runtime config unavailable:', error);
        return firebaseConfig;
    }
}
